module.exports = __webpack_public_path__ + "img/ico-default-avatar.7de5e5f7.svg";